import axios from "axios";
import { getToken } from "@/utils/auth";
import { Loading } from "element-ui";
import { Message } from "element-ui";
import store from "../store"; // 引入 Vuex store

const mimeMap = {
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  zip: "application/zip",
  pdf: "application/pdf",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
};

// const baseUrl = process.env.VUE_APP_BASE_API,
//'str'为下载路径
//'stly'为下载类型(默认xlsx)
//'name'下载文件名称
//'data'为入参
//'type'判断是否小程序接口(默认为php接口)
//'method'为请求方式(默认get请求)
export function downLoadZip(str, stly, name, params, type, method) {
  var imgdownUrl1 = "";
  // if (type == "app") {
  //   imgdownUrl1 = window.localStorage.getItem("appUrl");
  // } else if (type == "newphp") {
  //   imgdownUrl1 = window.localStorage.getItem("phpUrl");
  // } else {
  //   imgdownUrl1 = window.localStorage.getItem("oldphpUrl");
  // }

  // if (type == "app") {
  //   imgdownUrl1 = window.localStorage.getItem("appUrl");
  // } else {
  //   imgdownUrl1 = window.localStorage.getItem("phpUrl");
  // }
  imgdownUrl1 = window.localStorage.getItem("appUrl");
  var loading = Loading.service({
    lock: true,
    text: "下载中",
    spinner: "el-icon-loading",
    background: "rgba(0, 0, 0, 0.7)",
  });
  var url = imgdownUrl1 + str;

  var responseType = "";
  if (stly == "pdf") {
    responseType = "arraybuffer";
  }

  // 请求拦截器中获取 token
  let token = store.state.token; // 直接访问 state.token
  if (!token) {
    token = localStorage.getItem("token");
    if (token) {
      store.commit("SET_TOKEN", token); // 使用 mutation
    }
  }

  axios({
    method: method || "get",
    url: url,
    responseType: responseType || "blob",
    headers: { Authorization: `Bearer ${token}` },
    [method == "post" ? "data" : "params"]: params,
  }).then(async (response) => {
    const res = response.data;
    if (stly == "pdf" && response.headers["content-type"] === "text/html") {
      var enc = new TextDecoder("utf-8");
      let data = JSON.parse(enc.decode(new Uint8Array(res))) || {};
      loading.close();
      return Message({
        message: data.message || "服务器繁忙，请刷新重试",
        type: "error",
        duration: 5 * 1000,
      });
    }
    if (["text/html"].includes(res.type)) {
      var enc = new TextDecoder("utf-8");
      let BufferItem = await res.arrayBuffer();
      let data = JSON.parse(enc.decode(new Uint8Array(BufferItem))) || {};
      loading.close();
      return Message({
        message: data.message || "服务器繁忙，请刷新重试",
        type: "error",
        duration: 5 * 1000,
      });
    }

    var state = response.headers["content-type"];
    if (stly == "pdf") {
      state = mimeMap.pdf;
    }
    if (stly == "xlsx") {
      state = mimeMap.xlsx;
    }
    if (stly == "zip") {
      state = mimeMap.zip;
    }
    if (stly == "docx") {
      state = mimeMap.docx;
    }
    resolveBlob(response, state, name, loading);
  });
}
/**
 * 解析blob响应内容并下载
 * @param {*} res blob响应内容
 * @param {String} mimeType MIME类型
 */
export function resolveBlob(res, mimeType, name, loading) {
  const aLink = document.createElement("a");
  var blob = new Blob([res.data], { type: mimeType });
  // //从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
  // var patt = new RegExp('filename=([^;]+\\.[^\\.;]+);*')
  // var contentDisposition = decodeURI(res.headers['content-disposition'])
  // var result = patt.exec(contentDisposition)
  // var fileName = result[1]
  // fileName = fileName.replace(/\"/g, '')
  if (name == "") {
    let fileName = res.headers["content-disposition"];
    var name = decodeURIComponent(fileName).split("*=UTF-8''")[1];
  }

  aLink.href = URL.createObjectURL(blob);
  aLink.setAttribute("download", name); // 设置下载文件名称
  document.body.appendChild(aLink);
  aLink.click();
  document.body.appendChild(aLink);
  loading.close();
}
